import React, { useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useBreadcrumb } from '../../../contexts/BreadcrumbContext';

const AdminDashboardPage: React.FC = () => {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([{ label: 'Painel', path: '/admin' }]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            component={Link}
            to="/admin/opportunities"
            sx={{ textDecoration: 'none', height: '100%' }}
          >
            <CardContent>
              <Typography variant="h6" color="primary">
                Oportunidades
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visualizar e gerenciar todas as oportunidades
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/admin/quotes" sx={{ textDecoration: 'none', height: '100%' }}>
            <CardContent>
              <Typography variant="h6" color="primary">
                Cotações
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visualizar e gerenciar todas as cotações
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/admin/orders" sx={{ textDecoration: 'none', height: '100%' }}>
            <CardContent>
              <Typography variant="h6" color="primary">
                Pedidos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visualizar e gerenciar todos os pedidos
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card
            component={Link}
            to="/admin/products"
            sx={{ textDecoration: 'none', height: '100%' }}
          >
            <CardContent>
              <Typography variant="h6" color="primary">
                Produtos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visualizar e gerenciar todos os produtos
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card component={Link} to="/admin/users" sx={{ textDecoration: 'none', height: '100%' }}>
            <CardContent>
              <Typography variant="h6" color="primary">
                Usuários
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visualizar e gerenciar usuários
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboardPage;
